import React, { useState } from 'react'
 
 
import DirectFarmerPaymentList from './DirectFarmerPaymentList';
import DirectFarmerPaymentForm from './DirectFarmerPaymentForm';

const DirectFarmerPayment= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <DirectFarmerPaymentForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <DirectFarmerPaymentList addForm={setFromIsShown} update={setUpData}  sId={setServiceId} />
        )}  
    </>
  )
}

export default DirectFarmerPayment